import styled, { createGlobalStyle, css } from 'styled-components';
import { DateInput, Button as ButtonComponent } from 'junto-ui';
import LinkButton from '../../../../LinkButton';
import { tokens, palette } from '@plataforma/components';

export const Container = styled.form`
  display: flex;
  gap: ${tokens.spacing.l};
  align-items: center;
  margin-left: ${tokens.spacing.l};
`;

export const DateRangeContainer = styled.div`
  display: flex;
  position: relative;
  gap: ${tokens.spacing.m};
`;

export const HelpText = styled.p`
  ${tokens.font.xs}
  color: ${palette['color-grey-600']};
  position: absolute;
  bottom: -24px;
`;

export const DateField = styled(DateInput)`
  width: 100%;
  max-width: 210px;

  & > span {
    position: absolute;
    bottom: -22px;
    width: 211px;
    padding: 6px 0 0 0;
  }

  ${({ variant }) => variant === 'error' && css`
    & > div {
      border-color: ${palette.error};

      & > span {
        color: ${palette.error} !important;
      }

      & > svg {
        color: ${palette.error};
      }

      &:hover {
        border-color: ${palette.error};
      }

      &:focus-within {
        border-color: ${palette.error};
      }
    }

    & > span {
      color: ${palette.error};
    }
  `}
`;

export const Button = styled(ButtonComponent)`
  width: 133px;
`;

export const Link = styled(LinkButton)`
  height: 64px;
`;

export const ModalDeactive = createGlobalStyle`
  body {
    overflow: ${({ openCalendar }) => openCalendar ? 'hidden' : 'auto'};
  }
`;